if (!customElements.get('custom-collection-tabs')) {
  customElements.define(
    'custom-collection-tabs',
    class CustomCollectionTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (!this.tabs.length) return;

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.onBlockSelect = this.onBlockSelect.bind(this);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        this.panels.forEach((panel) => {
          const track = panel.querySelector('.custom-slider__track');
          if (!track) return;
          track.addEventListener('scroll', () => this.updateProgress(panel), { passive: true });
        });
        this.resizeObserver = new ResizeObserver(() => this.panels.forEach((panel) => this.updateProgress(panel)));
        this.resizeObserver.observe(this);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
      }

      updateProgress(panel) {
        const track = panel.querySelector('.custom-slider__track');
        const thumb = panel.querySelector('.custom-tabs__progress-thumb');
        if (!track || !thumb || panel.hidden || !track.scrollWidth) return;
        const visible = Math.min(1, track.clientWidth / track.scrollWidth);
        const maxScroll = track.scrollWidth - track.clientWidth;
        const position = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
        thumb.style.setProperty('--custom-progress-width', `${visible * 100}%`);
        // translateX percentages are relative to the thumb's own width.
        thumb.style.setProperty(
          '--custom-progress-offset',
          `${visible < 1 ? ((1 - visible) / visible) * position * 100 : 0}%`,
        );
      }

      select(index, focus = false) {
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          tab.classList.toggle('is-active', selected);
          if (this.panels[tabIndex]) this.panels[tabIndex].hidden = !selected;
        });

        if (this.panels[index]) this.updateProgress(this.panels[index]);
        if (focus) this.tabs[index].focus();
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next;

        switch (event.key) {
          case 'ArrowRight':
            next = index === last ? 0 : index + 1;
            break;
          case 'ArrowLeft':
            next = index === 0 ? last : index - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(next, true);
      }

      onBlockSelect(event) {
        const index = this.tabs.indexOf(event.target);
        if (index !== -1) this.select(index);
      }
    },
  );
}
